module.exports = __webpack_public_path__ + "static/img/manual_zh_19.f976699.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_19.png
// module id = sflA
// module chunks = 4